import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class WorkService {

	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {get} /v2/Drivers/:id/ActiveWorkOrders Get WorkOrders
	 * @apiName getWorkOrders
	 * @apiParam {string} [currentDate] Current Date
	 * @apiParam {string} [additionalDate] Additional Date
	 * @apiParam {number} [completedLookBackMinutes] Completed Look Back Minutes
	 * @apiGroup Drivers
	 * @apiVersion 20.0.0
	 */
	getWorkOrders(id, postDate) {
		const d = new Date();
		let params: HttpParams = new HttpParams();
		params = params.append('currentDate', d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2));
		params = params.append('additionalDate', postDate);
		params = params.append('completedLookBackMinutes', '1440');
		return this._http.get<any>(`${environment.apiUrl}/v2/Drivers/${id}/ActiveWorkOrders`, {params});
	}

	/**
	 * @api {patch} /v2/WorkOrders/:id Update WorkOrder Status
	 * @apiName updateStatus
	 * @apiGroup WorkOrders
	 * @apiVersion 20.0.0
	 */
	updateStatus(id, patch) {
		return this._http.patch<any>(`${environment.apiUrl}/v2/WorkOrders/${id}`, patch);
	}
}
